import React, { Component } from 'react';
import { Mail, MapPin, Send, Shield, Facebook, Twitter, Instagram } from 'lucide-react';
import { SEO } from '../components/layout/SEO';
import { Section } from '../components/ui/Section';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
import { FadeIn } from '../components/ui/FadeIn';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
export function ContactPage() {
  const {
    t,
    isRTL
  } = useLanguage();
  const emailSubject = encodeURIComponent('Website Enquiry');
  const emailBody = encodeURIComponent(`Name: [Your Full Name]

Contact Details: [Your Email/Phone]

Enquiry:
[Please describe your enquiry here]`);
  const mailtoLink = `mailto:info@kmauk.org?subject=${emailSubject}&body=${emailBody}`;
  return <>
      <SEO title={t('nav.contact')} description={t('contact.hero.subtitle')} data-id="element-296" />

      <div className="bg-[#1e5f4f] text-white py-16 md:py-20" data-id="element-297">
        <div className="container mx-auto px-4 text-center" data-id="element-298">
          <FadeIn data-id="element-299">
            <Mail className="h-12 w-12 mx-auto mb-6 text-white" data-id="element-300" />
            <h1 className="text-4xl md:text-5xl font-serif font-bold mb-4 text-white" data-id="element-301">
              Get In Touch
            </h1>
            <p className="text-xl text-white max-w-2xl mx-auto" data-id="element-302">
              Have questions about membership, events, or our charitable work?
              We're here to help.
            </p>
          </FadeIn>
        </div>
      </div>

      <Section data-id="element-303">
        <div className="max-w-5xl mx-auto" data-id="element-304">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-305">
            {/* Contact Information */}
            <FadeIn data-id="element-306">
              <div className="space-y-8" data-id="element-307">
                <div data-id="element-308">
                  <h2 className="text-2xl font-serif font-bold text-gray-900 mb-6" data-id="element-309">
                    {t('contact.getInTouch.title')}
                  </h2>
                  <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-310">
                    {t('contact.getInTouch.subtitle')}
                  </p>
                </div>

                <div className="space-y-6" data-id="element-311">
                  <Card className="border-primary-100" data-id="element-312">
                    <CardContent className="flex items-start p-6" data-id="element-313">
                      <div className={`flex-shrink-0 h-12 w-12 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center ${isRTL ? 'ml-4' : 'mr-4'}`} data-id="element-314">
                        <MapPin className="h-6 w-6" data-id="element-315" />
                      </div>
                      <div data-id="element-316">
                        <h3 className="font-bold text-gray-900 mb-2" data-id="element-317">
                          {t('contact.address.title')}
                        </h3>
                        <p className="text-gray-600 leading-relaxed" data-id="element-318">
                          17 Honeybourne
                          <br data-id="element-319" />
                          Bishop's Stortford
                          <br data-id="element-320" />
                          CM23 4EF
                          <br data-id="element-321" />
                          United Kingdom
                        </p>
                      </div>
                    </CardContent>
                  </Card>

                  <Card className="border-primary-100" data-id="element-322">
                    <CardContent className="flex items-center p-6" data-id="element-323">
                      <div className={`flex-shrink-0 h-12 w-12 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center ${isRTL ? 'ml-4' : 'mr-4'}`} data-id="element-324">
                        <Mail className="h-6 w-6" data-id="element-325" />
                      </div>
                      <div data-id="element-326">
                        <h3 className="font-bold text-gray-900 mb-2" data-id="element-327">
                          {t('contact.email.title')}
                        </h3>
                        <a href="mailto:info@kmauk.org" className="text-primary-700 hover:underline text-lg font-medium" data-id="element-328">
                          info@kmauk.org
                        </a>
                      </div>
                    </CardContent>
                  </Card>

                  {/* Social Media */}
                  <Card className="border-primary-100" data-id="element-329">
                    <CardContent className="p-6" data-id="element-330">
                      <h3 className="font-bold text-gray-900 mb-4" data-id="element-331">
                        Connect With Us
                      </h3>
                      <div className="flex gap-3" data-id="element-332">
                        <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="p-3 bg-gray-100 rounded-full hover:bg-primary-100 hover:text-primary-700 transition-colors" aria-label="Facebook" data-id="element-333">
                          <Facebook className="h-5 w-5" data-id="element-334" />
                        </a>
                        <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="p-3 bg-gray-100 rounded-full hover:bg-primary-100 hover:text-primary-700 transition-colors" aria-label="Twitter" data-id="element-335">
                          <Twitter className="h-5 w-5" data-id="element-336" />
                        </a>
                        <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="p-3 bg-gray-100 rounded-full hover:bg-primary-100 hover:text-primary-700 transition-colors" aria-label="Instagram" data-id="element-337">
                          <Instagram className="h-5 w-5" data-id="element-338" />
                        </a>
                      </div>
                    </CardContent>
                  </Card>
                </div>

                {/* Reassurance */}
                <div className="bg-green-50 border border-green-200 rounded-lg p-6" data-id="element-339">
                  <div className="flex items-start gap-3" data-id="element-340">
                    <Shield className="h-5 w-5 text-green-600 shrink-0 mt-0.5" data-id="element-341" />
                    <div data-id="element-342">
                      <h4 className="font-bold text-gray-900 mb-2" data-id="element-343">
                        {t('contact.privacy.title')}
                      </h4>
                      <p className="text-sm text-gray-700 leading-relaxed mb-2" data-id="element-344">
                        {t('contact.privacy.description')}
                      </p>
                      <Link to="/privacy" className="text-sm font-medium text-green-700 hover:underline" data-id="element-345">
                        {t('contact.privacy.link')}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </FadeIn>

            {/* Contact CTA Card */}
            <FadeIn delay={0.2} data-id="element-346">
              <Card className="border-primary-100 shadow-lg h-full flex flex-col" data-id="element-347">
                <CardContent className="p-8 flex-1 flex flex-col items-center justify-center text-center" data-id="element-348">
                  <div className="h-20 w-20 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center mb-6" data-id="element-349">
                    <Send className="h-10 w-10" data-id="element-350" />
                  </div>

                  <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-351">
                    Send Us an Email
                  </h3>

                  <p className="text-gray-600 mb-8 leading-relaxed max-w-md" data-id="element-352">
                    Click the button below to open your email client with a
                    pre-filled template. Simply fill in your details and send
                    your enquiry to us.
                  </p>

                  <a href={mailtoLink} className="w-full max-w-sm" data-id="element-353">
                    <Button size="lg" className="w-full" data-id="element-354">
                      <Mail className={`h-5 w-5 ${isRTL ? 'ml-2' : 'mr-2'}`} data-id="element-355" />
                      Contact Us
                    </Button>
                  </a>

                  <p className="text-xs text-gray-500 mt-6 max-w-md" data-id="element-356">
                    This will open your default email application with our email
                    address (info@kmauk.org) and a template for your message.
                  </p>
                </CardContent>
              </Card>
            </FadeIn>
          </div>
        </div>
      </Section>

      {/* Quick Links */}
      <Section background="gray" className="text-center" data-id="element-357">
        <FadeIn data-id="element-358">
          <h2 className="text-2xl font-serif font-bold text-gray-900 mb-8" data-id="element-359">
            {t('contact.quickLinks.title')}
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-4xl mx-auto" data-id="element-360">
            <Card className="hover:shadow-md transition-shadow" data-id="element-361">
              <CardContent className="p-6 text-center" data-id="element-362">
                <h3 className="font-bold text-gray-900 mb-2" data-id="element-363">
                  {t('contact.quickLinks.membership.title')}
                </h3>
                <p className="text-sm text-gray-600 mb-4" data-id="element-364">
                  {t('contact.quickLinks.membership.subtitle')}
                </p>
                <a href="/membership" className="text-primary-700 hover:underline text-sm font-medium" data-id="element-365">
                  {t('contact.quickLinks.membership.link')}
                </a>
              </CardContent>
            </Card>

            <Card className="hover:shadow-md transition-shadow" data-id="element-366">
              <CardContent className="p-6 text-center" data-id="element-367">
                <h3 className="font-bold text-gray-900 mb-2" data-id="element-368">
                  {t('contact.quickLinks.donations.title')}
                </h3>
                <p className="text-sm text-gray-600 mb-4" data-id="element-369">
                  {t('contact.quickLinks.donations.subtitle')}
                </p>
                <a href="/charity" className="text-primary-700 hover:underline text-sm font-medium" data-id="element-370">
                  {t('contact.quickLinks.donations.link')}
                </a>
              </CardContent>
            </Card>

            <Card className="hover:shadow-md transition-shadow" data-id="element-371">
              <CardContent className="p-6 text-center" data-id="element-372">
                <h3 className="font-bold text-gray-900 mb-2" data-id="element-373">
                  {t('contact.quickLinks.events.title')}
                </h3>
                <p className="text-sm text-gray-600 mb-4" data-id="element-374">
                  {t('contact.quickLinks.events.subtitle')}
                </p>
                <a href="/events" className="text-primary-700 hover:underline text-sm font-medium" data-id="element-375">
                  {t('contact.quickLinks.events.link')}
                </a>
              </CardContent>
            </Card>
          </div>
        </FadeIn>
      </Section>
    </>;
}